import React from 'react';
import classNames from 'classnames';
import { bool, number, oneOf } from 'prop-types';
import Corner from '../Corner';
import { POSITIONS } from '../constants';
import styles from './index.module.scss';

const OnlineIndicator = ({
    isOnline,
    indicatorSize,
    position,
    avatarSize
}) => {
    // Because the avatar can have a dynamic size, all the properties of this component need to be computed based on the avatar size
    const size = indicatorSize || Math.round(avatarSize * 0.25); // The size of the indicator needs to be 25% of the avatar size
    const borderWidth = Math.round(size * 0.25); // the size of the border needs to be 25% of the computed indicator size

    return (
        <Corner position={position}
            avatarSize={avatarSize}
            cornerSize={size}
            borderSize={borderWidth}
            className={styles.onlineIndicator}>
            <div style={{ borderWidth, width: size, height: size }}
                className={classNames(styles.onlineCircle, {
                    [styles.online]: isOnline,
                    [styles.offline]: !isOnline
                })}/>
        </Corner>
    );
};

OnlineIndicator.propTypes = {
    isOnline: bool.isRequired,
    indicatorSize: number,
    position: oneOf(Object.values(POSITIONS)),
    avatarSize: number
};

OnlineIndicator.defaultProps = {
    position: POSITIONS.BOTTOM_RIGHT,
    avatarSize: 24
};

export default OnlineIndicator;
